import { useTranslation } from 'react-i18next';
import { useState, useEffect } from "react";

// Material UI imports
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';

// Local imports
import { useActivitiesCompletion } from './ActivitiesCompletionContext'

const CompletionModal = () => {
    const [showGif, setShowGif] = useState(true);
    const { t } = useTranslation();

    const { openModal, setOpenModal } = useActivitiesCompletion();

    useEffect(() => {

        if (openModal) {
            setShowGif(true);
        }

        const timer = () => {
            setTimeout(() => {
                setShowGif(false);
            }, 2500); // GIF duration is 2.5 seconds
        }
        timer();

        return () => clearTimeout(timer);
    }, [openModal]);

    const handleClose = () => setOpenModal(false);

    return (
        <Modal
            open={openModal}
            onClose={handleClose}
            aria-labelledby="completion-modal-title"
            aria-describedby="completion-modal-description"
        >
            <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 500,
                    bgcolor: 'background.paper',
                    backgroundImage: showGif ? 'url(/images/congratulations-7600_512.gif)' : 'none',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    boxShadow: 24,
                    p: 4,
                }}
            >
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{ position: 'absolute', top: 8, right: 8 }}
                >
                    <CloseIcon />
                </IconButton>
                <CheckCircleIcon sx={{ fontSize: 60, color: 'green', display: 'block', margin: '0 auto', mb: 2 }} />
                <Typography id="completion-modal-title" variant="h5" sx={{ fontWeight: 'bold', textAlign: 'center' }}>{t('completion.title')}</Typography>
                <Typography id="completion-modal-description" variant='h6' sx={{ mt: 2, textAlign: 'center' }}>{t('completion.paragraph')}</Typography>
                <Button 
                    variant="contained" 
                    href="/" 
                    sx={{ 
                        margin: '0 auto', 
                        display: 'block', 
                        width: 'fit-content',
                        mt: 2
                    }}
                >
                    {t('completion.go_home')}
                </Button>
            </Box>
        </Modal>
    )
}

export default CompletionModal;